export default {
  isLoading: false,
  error: null,
  companies: [],
  formIsSubmitted: false,
  form: {},
  company: null,
}
